import api from '../../api';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //

export const FETCH_LISTING_BULKS_REQUEST = 'app/FeedPage/FETCH_LISTING_BULKS_REQUEST';
export const FETCH_LISTING_BULKS_SUCCESS = 'app/FeedPage/FETCH_LISTING_BULKS_SUCCESS';
export const FETCH_LISTING_BULKS_ERROR = 'app/FeedPage/FETCH_LISTING_BULKS_ERROR';

const initialState = {
  pagination: null,
  listingBulks: null,
  listingBulksError: null,
  listingBulksInProgress: false,
};

const manageFeedPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTING_BULKS_REQUEST:
      return {
        ...state,
        listingBulksInProgress: true,
        listingBulksError: null,
      };
    case FETCH_LISTING_BULKS_SUCCESS:
      return {
        ...state,
        listingBulks: payload.data.items,
        pagination: payload.data.meta,
        listingBulksInProgress: false,
      };
    case FETCH_LISTING_BULKS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, listingBulksInProgress: false, listingBulksError: payload };

    default:
      return state;
  }
};

export default manageFeedPageReducer;

export const fetchListingBulksRequest = () => ({
  type: FETCH_LISTING_BULKS_REQUEST,
});

export const fetchListingBulksSuccess = data => ({
  type: FETCH_LISTING_BULKS_SUCCESS,
  payload: { data },
});

export const fetchListingBulksError = error => ({
  type: FETCH_LISTING_BULKS_ERROR,
  payload: error,
});

export const queryListingBulk = queryParams => (dispatch, getState, sdk) => {
  dispatch(fetchListingBulksRequest());
  const { limit, page, sort = '-createdAt' } = queryParams || {};

  let params = {};
  if (limit) {
    params.$limit = limit;
  }
  if (page) {
    params.$page = page;
  }
  if (sort) {
    params.$sort = sort;
  }

  return api.listingBulks
    .getListingBulks(params)
    .then(res => {
      const data = {
        meta: {
          currentPage: res.data.currentPage,
          totalItems: res.data.totalItems,
          totalPages: res.data.totalPages,
        },
        items: res.data.items,
      };
      dispatch(fetchListingBulksSuccess(data));

      return res;
    })
    .catch(e => dispatch(fetchListingBulksError(e)));
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const queryParams = parse(search);

  return dispatch(queryListingBulk(queryParams));
};
